module.exports = __webpack_public_path__ + "static/media/brands_hidrotermal.c45303c2.svg";